import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { DMMoneyErrorType } from '#src/types/DMMoneyErrorTypes'

export default class DMMoneyError extends BaseError<DMMoneyErrorType> {
  constructor(
    public message: string,
    public code: DMMoneyErrorType,
    public options?: {
      cause?: unknown
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, DMMoneyError.prototype)
    this.name = this.constructor.name
  }
}
